<div class="flex flex-col gap-5 p-1 dashboard-container">
    <!-- Dashboard Content -->
    <div class="flex flex-col gap-5">
        <div class="flex flex-col md:flex-row items-stretch gap-5">
            <div class="w-full md:w-1/2">
                <div *ngIf="dashboardDataService.componentLoadingState().pulse" class="loading-skeleton h-full">
                    <div class="skeleton-card h-full">
                        <div class="flex flex-col items-center justify-center h-full gap-3">
                            <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                            <p class="text-gray-500 text-sm">Loading pulse...</p>
                        </div>
                    </div>
                </div>
                <app-pulse *ngIf="!dashboardDataService.componentLoadingState().pulse"></app-pulse>
            </div>
            <div class="w-full md:w-1/2">
                <shared-mission-vision-values></shared-mission-vision-values>
            </div>
        </div>

        <div class="flex flex-col md:flex-row items-stretch gap-5">
            <div class="w-full md:w-1/2">
                <div *ngIf="dashboardDataService.componentLoadingState().glMail" class="loading-skeleton h-full">
                    <div class="skeleton-card h-full">
                        <div class="flex flex-col items-center justify-center h-full gap-3">
                            <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                            <p class="text-gray-500 text-sm">Loading GL Mail...</p>
                        </div>
                    </div>
                </div>
                <app-gl-mail *ngIf="!dashboardDataService.componentLoadingState().glMail"></app-gl-mail>
            </div>
            <div class="w-full md:w-1/2">
                <app-verse-of-the-day></app-verse-of-the-day>
            </div>
        </div>

        <div class="w-full" *ngIf="dashboardDataService.knowBe4Data().length > 0">
            <div *ngIf="dashboardDataService.componentLoadingState().knowBe4Graphs" class="loading-skeleton">
                <div class="skeleton-card" style="height: 300px;">
                    <div class="flex flex-col items-center justify-center h-full gap-3">
                        <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                        <p class="text-gray-500 text-sm">Loading security metrics...</p>
                    </div>
                </div>
            </div>
            <app-know-be4-graphs *ngIf="!dashboardDataService.componentLoadingState().knowBe4Graphs"></app-know-be4-graphs>
        </div>

        <!-- KPI Dashboard - Only show if user has KPIs assigned -->
        <p-card *ngIf="hasKpis()" header="My KPIs" class="w-full">
            <app-individual-staff-kpi-report [inputKpiData]="currentStaffId()"></app-individual-staff-kpi-report>
        </p-card>

        <div *ngIf="dashboardDataService.componentLoadingState().registrationStats" class="loading-skeleton">
            <div class="skeleton-card" style="height: 500px;">
                <div class="flex flex-col items-center justify-center h-full gap-3">
                    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                    <p class="text-gray-500 text-sm">Loading registration statistics...</p>
                </div>
            </div>
        </div>
        <app-registration-stats *ngIf="!dashboardDataService.componentLoadingState().registrationStats && dashboardDataService.registrationProgress()"></app-registration-stats>

        <div *ngIf="dashboardDataService.componentLoadingState().callStats" class="loading-skeleton">
            <div class="skeleton-card" style="height: 500px;">
                <div class="flex flex-col items-center justify-center h-full gap-3">
                    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                    <p class="text-gray-500 text-sm">Loading call statistics...</p>
                </div>
            </div>
        </div>
        <app-call-stats *ngIf="!dashboardDataService.componentLoadingState().callStats && dashboardDataService.callCounts()"></app-call-stats>

        <div *ngIf="dashboardDataService.componentLoadingState().paymentStats" class="loading-skeleton">
            <div class="skeleton-card" style="height: 500px;">
                <div class="flex flex-col items-center justify-center h-full gap-3">
                    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
                    <p class="text-gray-500 text-sm">Loading payment statistics...</p>
                </div>
            </div>
        </div>
        <app-payment-stats *ngIf="!dashboardDataService.componentLoadingState().paymentStats && dashboardDataService.paymentProgress()"></app-payment-stats>

        <!-- Leadership Dashboard - Only for IT role and specific staff IDs -->
        @if (isLeadership()) {
            <!-- Leadership-only components -->
            <app-trip-actual-history-report-container></app-trip-actual-history-report-container>
            
            <app-google-analytics-panel></app-google-analytics-panel>
            
            <div class="flex flex-col md:flex-row items-stretch h-fit gap-5">
                <div class="w-full md:w-1/2">
                    <app-renewal-progress></app-renewal-progress>
                </div>
                <div class="w-full md:w-1/2">
                    <app-misc-stats></app-misc-stats>
                </div>
            </div>
            
            <!-- Standard components for leadership -->
            <div class="flex flex-col md:flex-row items-stretch h-fit gap-5">
                <div class="w-full md:w-1/2">
                    <app-my-registration-stats></app-my-registration-stats>
                </div>
                <div class="w-full md:w-1/2">
                    <app-my-call-stats></app-my-call-stats>
                </div>
            </div>
            
            <div class="flex flex-col md:flex-row items-stretch gap-5">
                <div class="w-full md:w-1/2">
                    <app-my-potential-trips [staffId]="currentStaffId()"></app-my-potential-trips>
                </div>
                <div class="w-full md:w-1/2">
                    <app-my-consulting-wrapper [staffId]="currentStaffId()"></app-my-consulting-wrapper>
                </div>
            </div>
            
            <div class="flex flex-col md:flex-row items-stretch h-full gap-5">
                <div class="w-full md:w-1/2">
                    <app-my-overdue-regi-fees [staffId]="currentStaffId()"></app-my-overdue-regi-fees>
                </div>
                <div class="w-full md:w-1/2">
                    <app-my-overdue-payments [staffId]="currentStaffId()"></app-my-overdue-payments>
                </div>
            </div>
            
            <div class="flex flex-col md:flex-row items-stretch h-fit gap-5">
                <div class="w-full md:w-1/3">
                    <app-recruiting-scheduled-activities [staffId]="currentStaffId()" timeframe="week" [maxHeight]="200">
                    </app-recruiting-scheduled-activities>
                </div>
                <div class="w-full md:w-1/3">
                    <app-consulting-scheduled-activities [staffId]="currentStaffId()" [maxHeight]="200">
                    </app-consulting-scheduled-activities>
                </div>
                <div class="w-full md:w-1/3">
                    <app-partner-scheduled-activities [staffId]="currentStaffId()" [maxHeight]="200">
                    </app-partner-scheduled-activities>
                </div>
            </div>
            <div>
                <app-all-scheduled-activities [staffId]="currentStaffId()"></app-all-scheduled-activities>
            </div>
        } @else {
            <!-- Standard Dashboard - For all other users -->
            <div class="flex flex-col md:flex-row items-stretch h-fit gap-5">
                <div class="w-full md:w-1/2">
                    <app-my-registration-stats></app-my-registration-stats>
                </div>
                <div class="w-full md:w-1/2">
                    <app-my-call-stats></app-my-call-stats>
                </div>
            </div>
            
            <div class="flex flex-col md:flex-row items-stretch gap-5">
                <div class="w-full md:w-1/2">
                    <app-my-potential-trips [staffId]="currentStaffId()"></app-my-potential-trips>
                </div>
                <div class="w-full md:w-1/2">
                    <app-my-consulting-wrapper [staffId]="currentStaffId()"></app-my-consulting-wrapper>
                </div>
            </div>
            
            <div class="flex flex-col md:flex-row items-stretch h-full gap-5">
                <div class="w-full md:w-1/2">
                    <app-my-overdue-regi-fees [staffId]="currentStaffId()"></app-my-overdue-regi-fees>
                </div>
                <div class="w-full md:w-1/2">
                    <app-my-overdue-payments [staffId]="currentStaffId()"></app-my-overdue-payments>
                </div>
            </div>
            
            <div class="flex flex-col md:flex-row items-stretch h-fit gap-5">
                <div class="w-full md:w-1/3">
                    <app-recruiting-scheduled-activities [staffId]="currentStaffId()" timeframe="week" [maxHeight]="200">
                    </app-recruiting-scheduled-activities>
                </div>
                <div class="w-full md:w-1/3">
                    <app-consulting-scheduled-activities [staffId]="currentStaffId()" [maxHeight]="200">
                    </app-consulting-scheduled-activities>
                </div>
                <div class="w-full md:w-1/3">
                    <app-partner-scheduled-activities [staffId]="currentStaffId()" [maxHeight]="200">
                    </app-partner-scheduled-activities>
                </div>
            </div>
            <div>
                <app-all-scheduled-activities [staffId]="currentStaffId()"></app-all-scheduled-activities>
            </div>
            
            <!-- Standard users also get PPM stats (view only) -->
            <app-trip-actual-history-report-container></app-trip-actual-history-report-container>
        }

    </div>
    @if (hasSupervisees()) {
      <app-supervisor-dashboard></app-supervisor-dashboard>
    }
</div>